import { Controller } from '@hotwired/stimulus'

// Live product search for homepage pin UI — updates results only, no page navigation/scroll.
export default class extends Controller {
  static targets = ['input', 'results', 'clear']

  static values = {
    url: String,
    delay: { type: Number, default: 280 }
  }

  connect () {
    this.timer = null
    this.abortController = null
    this.requestId = 0
    this.lastQuery = this.hasInputTarget ? this.inputTarget.value.trim() : ''
    this.syncClear()
  }

  disconnect () {
    if (this.timer) clearTimeout(this.timer)
    this.abortController?.abort()
  }

  queueSearch () {
    this.syncClear()
    if (this.timer) clearTimeout(this.timer)
    this.timer = window.setTimeout(() => this.search(), this.delayValue)
  }

  clear (event) {
    event?.preventDefault()
    if (this.timer) clearTimeout(this.timer)
    this.inputTarget.value = ''
    this.syncClear()
    this.search()
    this.inputTarget.focus({ preventScroll: true })
  }

  async search () {
    if (!this.hasResultsTarget || !this.urlValue) return

    const query = this.inputTarget.value.trim()
    if (query === this.lastQuery && this.requestId > 0) return
    this.lastQuery = query

    this.abortController?.abort()
    this.abortController = new AbortController()
    const requestId = ++this.requestId

    const url = new URL(this.urlValue, window.location.origin)
    if (query) url.searchParams.set('product_q', query)

    try {
      const response = await fetch(url.toString(), {
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        signal: this.abortController.signal
      })
      if (!response.ok) return
      const html = await response.text()
      if (requestId !== this.requestId) return
      this.resultsTarget.innerHTML = html
    } catch (error) {
      if (error?.name === 'AbortError') return
    }
  }

  syncClear () {
    if (!this.hasClearTarget) return
    this.clearTarget.classList.toggle('hidden', !this.inputTarget.value.trim())
  }
}
